import { Injectable } from '@angular/core';
import { AvisInitialService } from '../avisInitial/avis-initial.service';
import { NatureMarcheService } from '../natureMarche/nature-marche.service';

@Injectable({
	providedIn: 'root',
})
export class AnnulationService {
	constructor(public avisInitialService: AvisInitialService, public natureMarcheService: NatureMarcheService) {}
}
